import IBContractPage from './IBContractPage';

export default IBContractPage;
export { IBContractPage };
